import { render, staticRenderFns } from "./DeleteUserConfirmModal.vue?vue&type=template&id=35d8c0a6&"
import script from "./DeleteUserConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteUserConfirmModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteUserConfirmModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports